module.exports = __webpack_public_path__ + "static/img/defender.0251b11e.svg";